import { useMemo } from "react";
import { BurnAssessmentColor } from "../BurnAssessmentColor";
import { TFunction } from "i18next";
import { BarSeriesType, LineSeriesType } from "@mui/x-charts-premium";
import { orange } from "@mui/material/colors";

export const useSeries = (
  showIgnitionQualityCount: boolean,
  showGoodInPercent: boolean,
  showRawGoodInPercent: boolean,
  t: TFunction<"firefly-shared-ts-domain">
): Array<BarSeriesType | LineSeriesType> => {
  return useMemo(() => {
    const goodInPercentSeries = {
      id: "goodInPercent",
      yAxisId: "percentage",
      label: t("Good ignitions in %"),
      type: "line",
      dataKey: "goodInPercent",
      color: orange[500],
      connectNulls: true,
    } as LineSeriesType;

    const goodInPercentRawSeries = {
      id: "goodInPercentRaw",
      yAxisId: "percentage",
      label: "Good ignitions in % (raw)",
      type: "line",
      dataKey: "goodInPercentRaw",
      connectNulls: true,
    } as LineSeriesType;

    const excellentSeries = {
      id: "excellent",
      yAxisId: "burnCount",
      label: t("BurnAssessment.Good Ignitions"),
      type: "bar",
      stack: "total",
      stackOrder: "reverse",
      dataKey: "excellent",
      color: BurnAssessmentColor.Good,
    } as BarSeriesType;

    const goodSeries = {
      id: "good",
      yAxisId: "burnCount",
      label: t("BurnAssessment.Normal Ignitions"),
      type: "bar",
      stack: "total",
      stackOrder: "reverse",
      dataKey: "good",
      color: BurnAssessmentColor.Normal,
    } as BarSeriesType;

    const badSeries = {
      id: "bad",
      yAxisId: "burnCount",
      label: t("BurnAssessment.Bad Ignitions"),
      type: "bar",
      stack: "total",
      stackOrder: "reverse",
      dataKey: "bad",
      color: BurnAssessmentColor.Bad,
    } as BarSeriesType;

    const unknownSeries = {
      id: "unknown",
      yAxisId: "burnCount",
      label: t("BurnAssessment.Unknown Ignitions"),
      type: "bar",
      stack: "total",
      stackOrder: "reverse",
      dataKey: "unknown",
      color: BurnAssessmentColor.Unknown,
    } as BarSeriesType;

    const arrayOfSeries: Array<LineSeriesType | BarSeriesType> = [];

    if (showGoodInPercent) {
      arrayOfSeries.push(goodInPercentSeries);
    }
    if (showGoodInPercent && showRawGoodInPercent) {
      arrayOfSeries.push(goodInPercentRawSeries);
    }

    if (showIgnitionQualityCount) {
      arrayOfSeries.push(excellentSeries);
      arrayOfSeries.push(goodSeries);
      arrayOfSeries.push(badSeries);
      arrayOfSeries.push(unknownSeries);
    }

    return arrayOfSeries;
  }, [t, showGoodInPercent, showRawGoodInPercent, showIgnitionQualityCount]);
};
